import { formatFromChannel, getSalesforceTicketDisplayName } from 'util/index';
import { makeDisplayName } from '../../../util/formatUtil';
import * as sources from 'constants/sources';
import * as directions from 'constants/messageDirection';
import { SALESFORCE, SALESFORCE_CHAT } from 'constants/conversationTypes';
import React from 'react';
import * as colors from 'components/common/colorConstants';
import { isMessageFromCurrentUser } from 'util/messageUtil';
import { ToolTip } from 'components/common/tooltips';
import { Highlight, Text } from './SenderInDisplayComponent.styles';

export const SenderInDisplayComponent = ({ message, isAdmin, isLiveChat }) => {
  if (message.source === sources.SMB) {
    // if the source is from the business then show the business name
    return (
      <Text isLiveChat={isLiveChat}>
        <Highlight color={colors.gold}>PARTNER AGENT</Highlight> {message.smbName}
      </Text>
    );
  }
  // Simplr admin in ticketing system
  if (message.direction === directions.OUTBOUND && !message.expert && message.source === 'SIMPLR') {
    return (
      <Text isLiveChat={isLiveChat}>
        <Highlight color={colors.lightGray20}>EXPERT</Highlight>
        Expert
      </Text>
    );
  }
  if (message.source === sources.SMB_BOT) {
    return (
      <Text isLiveChat={isLiveChat}>
        <Highlight color={colors.gold}>PARTNER BOT</Highlight> {message.smbName}
      </Text>
    );
  }

  if (message.direction && message.direction === directions.INBOUND) {
    let displayName = '';
    if (message.messageType === SALESFORCE || message.messageType === SALESFORCE_CHAT) {
      displayName = getSalesforceTicketDisplayName(message.customerFirstName, isAdmin, message.platformTicketId);
    } else if (message.customerFirstName) {
      displayName = message.customerFirstName;
    } else {
      displayName = formatFromChannel(message.messageType, message.fromChannel);
    }

    return (
      <Text isLiveChat={isLiveChat}>
        <Highlight color={colors.green2}>CUSTOMER</Highlight> {displayName}
      </Text>
    );
  }
  if (!message.expert) {
    // this condition should never hit but we need it to prevent the application from crashing
    return (
      <Text isLiveChat={isLiveChat}>
        <Highlight color={colors.lightGray20}>UNKNOWN</Highlight>
      </Text>
    );
  }
  if (isAdmin || isMessageFromCurrentUser(message)) {
    const displayName = makeDisplayName({
      firstName: message.expert.firstName,
      lastName: message.expert.lastName,
    });

    // only show full name if expert is a specialist or message is from the current user
    return (
      <Text isLiveChat={isLiveChat}>
        <Highlight color={colors.lightGray20}>{message.expert.isAdmin ? 'SPECIALIST' : 'EXPERT'}</Highlight>{' '}
        {isAdmin ? (
          <ToolTip arrow interactive placement="top" content={`ID: ${message.expert.simplrExpertId}`}>
            <Text isLiveChat={isLiveChat}>{displayName}</Text>
          </ToolTip>
        ) : (
          displayName
        )}
      </Text>
    );
  }

  // if simplr admin bot obfuscate name as Expert
  if (message.expert.isSystemExpert) {
    return (
      <Text isLiveChat={isLiveChat}>
        <Highlight color={colors.lightGray20}>{message.expert.isAdmin ? 'SPECIALIST' : 'EXPERT'}</Highlight>
        Expert
      </Text>
    );
  }

  // hide name but indicate is specialist or expert
  if (message.expert.isAdmin) {
    return (
      <Text isLiveChat={isLiveChat}>
        <Highlight color={colors.lightGray20}>SPECIALIST</Highlight>
        {message.expert.obfuscatedName}
      </Text>
    );
  }

  return (
    <Text isLiveChat={isLiveChat}>
      <Highlight color={colors.lightGray20}>EXPERT</Highlight>
      {message.expert.obfuscatedName}
    </Text>
  );
};
